import { useParams } from "react-router-dom"

import { applyDiscount, fetchBookingDetails } from "modules/Payment/common/api"
import { BookingStatusMap, ErrorResponse } from "utils/interfaces"
import { usePaymentContext } from "modules/Payment/PaymentContext"
import { useGetPrice } from "modules/Payment/common/hooks"
import { putOrderAutoPay, updateCurrency } from "modules/BookingCommon/common/api"

export function useApi(isAutoPay: boolean) {
    const { id } = useParams<{ id: string }>()
    const [
        { bookingDetails, currency, selectedDiscount, payByCard, bookingStatus },
        { setBookingDetails, toggleBookSessionIsLoading, setBookSessionError, nextPage },
    ] = usePaymentContext()
    const [, discountPrice] = useGetPrice()

    function runPutOrderAutoPay(orderId: string, externalId: string) {
        putOrderAutoPay(orderId, externalId)
            .then(() => {
                window.location.reload()
                toggleBookSessionIsLoading()
            })
            .catch(() => {
                setBookSessionError("Произошла ошибка оплаты через вашу карту")
                toggleBookSessionIsLoading()
            })
    }

    async function submitToPayment() {
        toggleBookSessionIsLoading()

        try {
            const updateState: Record<string, number> = {}

            if (
                bookingStatus === BookingStatusMap.NOT_PAID ||
                bookingStatus === BookingStatusMap.PAY_STARTED ||
                bookingStatus === BookingStatusMap.PAY_ERROR
            ) {
                const { price, discount } = await applyDiscount(
                    bookingDetails.booking_id,
                    selectedDiscount
                )
                if (discount) {
                    updateState.price = price
                }
            }

            if (discountPrice !== 0) {
                const { payment_system, price_usd } = await updateCurrency(
                    bookingDetails.order_hash,
                    currency
                )

                setBookingDetails({
                    ...bookingDetails,
                    ...updateState,
                    price_usd,
                    payment_system,
                })

                if (payByCard && isAutoPay && id) {
                    const { order_id } = await fetchBookingDetails(id)
                    runPutOrderAutoPay(order_id, payByCard.external_id)
                } else {
                    nextPage()
                }
            } else {
                window.location.reload()
            }
        } catch (e) {
            const error = e as ErrorResponse
            setBookSessionError(error.message)
            toggleBookSessionIsLoading()
        }
    }

    return {
        submitToPayment,
    }
}
